import { RecommendationsEvents } from 'es6/views/recommendations/recommendations-datalayer-events'

/**
 * Инициализация событий для Рекомендаций
 */
export const recommendationsEvents = new RecommendationsEvents()
